import styled from '@emotion/styled';

import Button from '../Button';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	> .button {
		background-color: var(--red-hover);
		border-color: var(--red-hover);

		&.green-button {
			background-color: var(--green-hover);
			border-color: var(--green-hover);
		}

		body[dir='rtl'] & {
			.icon {
				transform: scale(-1, 1);
			}
		}
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	position: relative;
	width: 100%;

	> .left-icon {
		position: absolute;
		display: flex;
		left: 1rem;
		top: 50%;
		transform: translateY(-50%);

		body[dir='rtl'] & {
			right: 0.5rem;
			left: unset;
		}
	}
	> .right-icon {
		position: absolute;
		display: flex;
		right: 0.5rem;
		top: 50%;
		transform: translateY(-50%);

		body[dir='rtl'] & {
			left: 0.5rem;
			right: unset;
		}
	}

	> input {
		padding-left: 3.5rem;
		padding-right: ${({ variant }) => (variant === 'scanner' ? '8rem' : '2.5rem')};

		body[dir='rtl'] & {
			padding-left: ${({ variant }) => (variant === 'scanner' ? '8rem' : '2.5rem')};
			padding-right: 3.5rem;
		}
	}
`;

export const AddButton = styled(Button)`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	right: 0.5rem;
	top: 50%;
	transform: translateY(-50%);

	body[dir='rtl'] & {
		left: 0.5rem;
		right: unset;
	}
`;
